import { useEffect, useRef } from "react";
import { getActiveAuth, clearActiveAuth } from "../api/axios";

// Auto logout after inactivity (default 30 minutes)
export default function IdleLogout({ timeoutMs = 30 * 60 * 1000 }) {
  const timerRef = useRef(null);

  const logout = () => {
    clearActiveAuth();
    window.location.href = "/login";
  };

  const reset = () => {
    const { token } = getActiveAuth();
    if (!token) return; // only when logged in
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, timeoutMs);
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
      "click",
      "focus",
    ];

    const handler = () => reset();

    events.forEach((e) => window.addEventListener(e, handler, { passive: true }));

    // Start timer
    reset();

    // Also react to other tabs logging out
    const onStorage = (e) => {
      if (e.key === "token" && !e.newValue) {
        window.location.href = "/login";
      }
    };
    window.addEventListener("storage", onStorage);

    return () => {
      events.forEach((e) => window.removeEventListener(e, handler));
      window.removeEventListener("storage", onStorage);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeoutMs]);

  return null;
}
